import { render, staticRenderFns } from "./surveillanceAI.vue?vue&type=template&id=1373c9a8&scoped=true"
import script from "./surveillanceAI.vue?vue&type=script&lang=js"
export * from "./surveillanceAI.vue?vue&type=script&lang=js"
import style0 from "./surveillanceAI.vue?vue&type=style&index=0&id=1373c9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1373c9a8",
  null
  
)

export default component.exports